'use client';

import type { LinkProps } from '@coolblue-development/freddy';
import { Link } from '@coolblue-development/freddy';
import styled from '@emotion/styled';
import { ComponentPropsWithoutRef } from 'react';

type SpecificationLinkProps =
  | (LinkProps & { component?: 'a' })
  | (LinkProps & { component: 'button' } & ComponentPropsWithoutRef<'button'>);

const SpecificationLink = styled(Link)<SpecificationLinkProps>`
  color: ${({ theme }) => theme.color.font.additional};
  cursor: pointer;
  text-align: left;
  text-decoration: underline dashed ${({ theme }) => theme.color.font.additional};
  text-underline-offset: 4px;

  &:hover {
    text-decoration: underline;
    color: ${({ theme }) => theme.color.font.subtle};
  }
`;

export default SpecificationLink;
